import React from 'react';

import { BRIDGE_NEW_CONSTRUCTION_PATH } from 'constants/routes';

import {
  Product,
  ProductBody,
  ProductList,
  ProductThumb,
  IconDiv,
  ProductHeader,
} from '../styles';
import { HomePageButtonNew } from 'components/temoraryHomePage';
import { Icon } from 'components/shared';
import thumb from './thumb.jpeg';

function NewConstruction() {
  const advantages = [
    'Up to 85% LTC (land and construction)',
    'Up to 70% of After-Build Value',
    '12-24 Months, Interest-Only ',
    'Loan Amounts from $200K to $2M',
  ];

  return (
    <Product color="newconstruction" to={BRIDGE_NEW_CONSTRUCTION_PATH}>
      <div>
        <div>
          <ProductHeader>
            <IconDiv>
              <Icon icon='home' />
            </IconDiv>
            New Construction
          </ProductHeader>
          <ProductThumb src={thumb} />
        </div>
        <ProductBody>
          <ProductList>{advantages}</ProductList>
        </ProductBody>
      </div>
      <HomePageButtonNew>Apply now</HomePageButtonNew>
    </Product>
  );
}

export default NewConstruction;
